<div class="front-wrap dv-ordr-dtls">
  <div class="front-store-content" [ngClass]="[(userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') ? 'content-blk' : '']">
    <div class="container">
      <div class="dash-head text-center od-head"
           *ngIf="userRole != 'StoreAdmin' && userRole != 'StoreOwner' && userRole != 'StoreStaffMember'">
        <h3>Order Details</h3>
      </div>
      <h5 class="page-title"
          *ngIf="userRole == 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'">
        Order Details
        <small class="pull-right title-link">
          <a [routerLink]="['/store/report/orders']">Orders List</a>
          <a *ngIf="!orderDetail.IsOrderDeskOrder" [routerLink]="['/store/commissions']">Commission List</a>
        </small>
        <span class="clearfix"></span>
      </h5>
      <div class="white-background">
        <div class="row od-shp-btm">
          <div class="col-sm-7 shp-ad">
            <div class="white-bx">
              <p>
                Order#: <span class="fontIncrease"><b>{{orderDetail.OrderNo}}</b></span>
                <sup class="text-danger" *ngIf="orderDetail.IsSampleOrder && !orderDetail.IsShopifyOrder">
                  <b>
                    &nbsp;*
                    Sample Order
                  </b>
                </sup>
                <sup class="text-danger" *ngIf="orderDetail.IsShopifyOrder && orderDetail.IsSampleOrder">
                  <b>
                    &nbsp;*
                    Shopify Order
                  </b>
                </sup>
                <sup class="text-danger" *ngIf="orderDetail.IsReplacementOrder"> <b>&nbsp;* Replacement Order For {{orderDetail.ParentOrderNo}}</b></sup>
                <sup class="text-danger" *ngIf="orderDetail.IsOrderDeskOrder">
                  <b>
                    &nbsp; <img src="assets/img/orderdesk_black.png" /> * Order Desk Order
                  </b>
                </sup>
              </p>
              <p *ngIf="orderDetail.storeDetail.IsShopifyStore">
                Shopify Store: <span class="Shopify-store">
                  {{orderDetail.storeDetail.StoreName}}
                </span>
              </p>

              <p class="oldordrno" *ngIf="userRole === 'SuperAdmin' || userRole ==='CustomerService'">
                SB Order#:<span><b> {{orderDetail.OldOrderNo}}</b></span>
              </p>
              <p *ngIf="orderDetail.IsShopifyOrder">
                Shopify#:<span class="fontIncrease"><b>{{orderDetail.ShopifyOrderNo}}</b></span>
              </p>

              <p *ngIf="orderDetail.IsOrderDeskOrder">
                Order Desk#:<span class="fontIncrease"><b>{{orderDetail.SourceOrderNumber}}</b></span>
              </p>
              <p>
                ORDER DATE : <strong class="od-stt-clr">
                  {{ getDate(orderDetail.OrderDate,false) |date:'fullDate'}}
                </strong>
              </p>
              <p *ngIf="orderDetail.PaymentMode">
                Payment Mode : <strong class="od-stt-clr">{{orderDetail.PaymentMode}}</strong>
              </p>
              <p *ngIf="orderDetail.IsShopifyOrder">
                Payment : <strong class="od-stt-clr">{{orderDetail.StatusOrderBrainTree.Status}}</strong>
              </p>
              <p class="od-status-blk is-st-pay" *ngIf="orderDetail.IsRefunded">
                Payment Status : <strong>Refunded</strong> <br>
                <mat-hint style="font-size: 10px;">
                  Your amount has been refunded on
                  {{getDate(orderDetail.RefundDate,false) | date:'fullDate'}}
                </mat-hint>
              </p>
              <p>
                Order Status : <strong class="od-stt-clr">{{orderDetail.OrderStatus}}</strong> <br>
                <mat-hint style="font-size: 10px;">
                  {{orderDetail.OrderStatusId == 4 ? 'Your order has been cancelled on ' + (getDate(orderDetail.CancelledDate,false) | date:'fullDate') : ''}}
                </mat-hint>
              </p>
              <br />
              <p  *ngIf="orderDetail.TransactionDetail != null" class="text-info" (click)="handleTransactionDetail(orderDetail.TransactionDetail, orderDetail.OrderNo)">
                View Transaction details
              </p>
              <br />
              <a style="cursor:pointer;color:#fff!important;"
                 *ngIf="(userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember' || userRole === 'SuperAdmin'|| userRole ==='CustomerService') && orderDetail.OrderStatusId < 4 && orderDetail.CancelOrderRequestStatus == 0"
                 (click)="RequestCancelOrder()" class="mat-btn cancel-order"> Cancel Order</a>
              <span *ngIf="orderDetail.CancelOrderRequestStatus == 1" class="text-danger">
                <b>Requested for Cancellation</b><br />
                <ng-container *ngIf="!orderDetail.IsOrderDeskOrder">
                  <small *ngIf="orderDetail.IsRefunded">
                    <strong>Refund Status :</strong><span class="text-info">
                      &nbsp;
                      Refunded
                    </span><br /><span style="color:black">
                      Your amount has been refunded on
                      {{getDate(OrderDetail.RefundDate,false) | date:'fullDate'}}
                    </span>
                  </small>
                  <small *ngIf="!orderDetail.IsRefunded">
                    <strong>Refund Status :</strong> <span class="text-danger">&nbsp;Pending...</span>
                  </small>
                </ng-container>
              </span>
              <span *ngIf="orderDetail.CancelOrderRequestStatus == 2" class="text-success">
                <b>Cancellation request Approved </b>
              </span>
              <span *ngIf="orderDetail.CancelOrderRequestStatus == 3" class="text-danger">
                <b>Cancellation request Rejected </b>
              </span>

              <ng-container *ngIf="!orderDetail.IsOrderDeskOrder">
                <a style="cursor: pointer; color: #fff !important; padding: 5px;" class="mat-btn"
                   *ngIf="(userRole == 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && fn_ShowReportOrder(orderDetail)"
                   (click)="fn_ReportOrder(orderDetail)">Report</a>
                <a style="cursor: pointer; color: #fff !important;" class="mat-btn"
                   *ngIf="orderDetail.ReportOrderStatus" [style.background]="getColor(orderDetail)">
                  {{fn_ReportOrderStatus(orderDetail)}}
                </a>
              </ng-container>
              <p *ngIf="orderDetail.AssginOrderFileExist && (userRole === 'SuperAdmin' || userRole ==='CustomerService')">
                Impress assign order object:
                <a target="_blank" [href]="fn_assignOrderObjectLink(orderDetail.OldOrderNo, 'Request')">
                  Request <i class="fa fa-download"></i>
                </a> &nbsp;
                <a target="_blank" [href]="fn_assignOrderObjectLink(orderDetail.OldOrderNo, 'Response')">
                  Response <i class="fa fa-download"></i>
                </a>
              </p>

              <ng-container *ngIf="orderDetail.ReleaseErrorMessage != null && (userRole === 'SuperAdmin' || userRole === 'CustomerService')">
                <p class="rlserrmsg">Impress release error: <small>{{orderDetail.ReleaseErrorMessage}}</small> </p>
              </ng-container>

              <ng-container *ngIf="!orderDetail.IsOrderDeskOrder">
                <a style="cursor: pointer;color:white!important;" class="mat-btn rep-ordr" *ngIf="fn_ShowReportOrderReplacement(orderDetail)"
                   (click)="fn_ReportOrderReplacement(orderDetail)">Request Replacement</a>
                <a style="cursor: pointer; color: white !important;margin-left: 10px;" class="mat-btn" *ngIf="orderDetail.ReportOrderStatus" [style.background]="getColor(orderDetail)">
                  {{fn_ReportOrderStatusReplacement(orderDetail)}}
                </a>
              </ng-container>
            </div>
          </div>
          <div class="col-sm-5 shp-ad text-right">
            <div class="white-bx" style="height: 194px;">
              <h4>Shipping Address</h4>
              <p>{{orderDetail.AddressModel.Name}}<br /></p>
              <p>
                {{orderDetail.AddressModel.AddressLine}} <br />
                <ng-container *ngIf="orderDetail.AddressModel.AddressLine2">
                  {{orderDetail.AddressModel.AddressLine2}} <br />
                </ng-container>
                {{orderDetail.AddressModel.Country}} {{orderDetail.AddressModel.CountryCode}},
                {{orderDetail.AddressModel.State}}
                {{orderDetail.AddressModel.StateCode}} - {{orderDetail.AddressModel.ZipCode}} <br />
                <strong>Contact No.: </strong> {{orderDetail.AddressModel.PhoneNumber | mask: '(000) 000-0000'}}

              </p>
              <p *ngIf="!isWarehouseProductOrder && orderDetail.ExpectedShipDate != null && orderDetail.OrderStatusId != 5 && orderDetail.OrderStatusId != 6 && orderDetail.OrderStatusId != 4">
                <strong>Expected ship date: </strong> {{orderDetail.ExpectedShipDate}}
              </p>
              <p *ngIf="orderDeskNo != null && orderDeskNo != 0"> <strong>Order Desk No: </strong> {{orderDeskNo}}</p>
              <a style="cursor:pointer;color:#fff!important;"
                 *ngIf="(userRole === 'SuperAdmin'|| userRole ==='CustomerService') && (orderDeskNo == null || orderDeskNo == 0) && (orderDetail.OrderStatusId !== 1)"
                 (click)="requestSubmitOrderToOrderDesk(orderDetail.OrderNo)" class="mat-btn cancel-order">
                Submit to
                order Desk
              </a>

            </div>
            <div *ngIf="orderDetail.TrackingNumber !== null" class="white-bx" style="height: 109px; margin-top: 19px;">
              <h4>Tracking Number</h4>
              <p>
                <strong>Tracking link: </strong> <a target="_blank" [href]="orderDetail.TrackingUrl">{{link}}</a><br>
                <strong>Tracking link: </strong> <a>{{orderDetail.TrackingUrl}}</a><br>
                <strong>TrackingNumber: </strong> {{orderDetail.TrackingNumber}}
              </p>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <div class="trck-prdct-lst">
              <div class="sp-crt-hd">
                <div class="row">
                  <div class="col-12 col-sm-2 col-md-2 text-center">
                    <h4 class="product-name"><strong>&nbsp;</strong></h4>
                  </div>
                  <div class="col-12 text-xs-center col-sm-5 text-md-left col-md-5">
                    <h4 class="product-name"><strong>Product </strong></h4>
                  </div>
                  <div class="col-12 col-sm-5 text-xs-center col-md-5 row">
                    <div class="col-3 col-sm-4 col-md-4 text-left">
                    </div>
                    <div class="col-9 col-sm-8 col-md-8"
                         *ngIf="(orderDetail.OrderStatusId == 4 || orderDetail.OrderStatusId == 6) && userRole === 'EndUser'; else notShow">
                      <div class="row">
                        <div class="col-5 col-md-5 text-center">
                        </div>
                        <div class="col-7 col-md-7 text-center"
                             *ngIf="(orderDetail.OrderStatusId == 4 || orderDetail.OrderStatusId == 6) && userRole === 'EndUser'">
                          <h4><strong>Rating</strong></h4>
                        </div>
                      </div>
                    </div>
                    <ng-template #notShow>
                      <div class="col-9 col-sm-8 col-md-8 text-right">
                        <h4><strong>Cost</strong></h4>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="crt-rw-rpt" *ngFor="let item of orderDetail.OrderItems">
                <div class="row">
                  <div *ngIf="!item.IsWareHouseProduct" class="col-12 col-sm-2 col-md-2 text-center"
                       style="padding:0px;">
                    <img [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}"
                         (click)="(!orderDetail.IsOrderDeskOrder && userRole === 'SuperAdmin'||userRole==='CustomerService') ? '': fn_ViewProduct(item.ProductId, item.DesignId, 1)"
                         *ngIf="item.IsImageCustom" src="{{imgCustomBaseURL + item.ImageName}}" />
                    <img [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}"
                         (click)="(!orderDetail.IsOrderDeskOrder && userRole === 'SuperAdmin'||userRole==='CustomerService') ? '': fn_ViewProduct(item.ProductId, item.DesignId, 1)"
                         *ngIf="!item.IsImageCustom" src="{{imgBaseURL + item.ImageName}}" />
                  </div>
                  <div *ngIf="item.IsWareHouseProduct && item.DesignId == 0"
                       class="col-12 col-sm-2 col-md-2 text-center" style="padding:0px;">
                    <img [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}"
                         (click)="(userRole === 'SuperAdmin'||userRole==='CustomerService') ? '': fn_ViewProduct(item.ProductId, item.DesignId, 1)"
                         src="{{imgWareHouseBaseURL + item.ImageName}}" />
                  </div>
                  <div *ngIf="item.IsWareHouseProduct && item.DesignId > 0"
                       class="col-12 col-sm-2 col-md-2 text-center">
                    <img [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}"
                         (click)="(userRole === 'SuperAdmin'||userRole==='CustomerService') ? '': fn_ViewProduct(item.ProductId, item.DesignId, 1)"
                         src="{{item.ImageName}}" />
                  </div>
                  <div class="col-12 text-xs-center col-sm-5 text-md-left col-md-5">
                    <p>
                      <mat-label [ngStyle]="{'cursor': userRole === 'EndUser' ? 'pointer' : 'default'}"
                                 (click)="(!orderDetail.IsOrderDeskOrder && userRole === 'SuperAdmin'||userRole==='CustomerService') ? '': fn_ViewProduct(item.ProductId, item.DesignId, 1)"
                                 class="product-name">
                        <strong>Product Name:</strong>
                        {{item.DesignName}}&nbsp;<span *ngIf="!item.IsWareHouseProduct" style="font-size:10px"
                                                       class="text-info">({{item.CustomizeType}})</span>
                      </mat-label><br>
                      <strong>Size: </strong> {{item.SizeName}}<br />
                      <strong>Color: </strong> {{item.ColorName}}<br />
                      <strong>Quantity: </strong>{{item.Quantity}}<br />
                      <strong>Price x Qty: </strong>
                      <ng-container *ngIf="orderDetail.IsShopifyOrder && item.ShopifyUnitPrice > 0">{{item.ShopifyUnitPrice | currency:'USD':'symbol':'1.2-2'}}</ng-container>
                      <ng-container *ngIf="!(orderDetail.IsShopifyOrder && item.ShopifyUnitPrice > 0)">{{item.UnitPrice | currency:'USD':'symbol':'1.2-2'}}</ng-container>
                      x {{
                      item.Quantity
                      }}<br />
                      <small *ngIf="item.IsWareHouseProduct && userRole==='EndUser'" class="text-danger">
                        ***WareHouse
                        Product
                      </small>
                      <strong>Item Status: </strong>
                      <span class="text-danger" *ngIf="item.IsCancelled">Cancelled</span>
                      <span *ngIf="!item.IsCancelled">{{item.ItemStatus}}</span>
                      <br />
                      <small *ngIf="item.FinishingPrice>0 && userRole === 'SuperAdmin'" class="text-info">
                        Finshing pirce
                        of {{item.FinishingPrice| currency:'USD':'symbol':'1.2-2'}} included.
                      </small>
                      <strong *ngIf="item.IsEmbroideryType == true && item.EmbDesignCode != null && item.EmbDesignCode != 0">ArtWork No: </strong> <span *ngIf="(item.IsEmbroideryType == true && (item.EmbDesignCode != null && item.EmbDesignCode != 0 ))">{{item.EmbDesignCode}}</span>
                      &nbsp;
                      <a style="cursor:pointer;color:#fff!important; padding: 3px;"
                         *ngIf="orderDetail.OrderStatusId < 4 && (userRole === 'SuperAdmin' || userRole ==='CustomerService') && item.IsEmbroideryType == true && item.EmbDesignCode != null && item.EmbDesignCode != 0"
                         (click)="requestRegenerateArtworkNo(item.CustomizedProductid,orderDetail.OldOrderNo)" class="mat-btn gen-art">
                        Regenerate
                      </a>

                    </p>

                  </div>
                  <div class="col-12 col-sm-5 text-xs-center col-md-5 row">
                    <div class="col-3 col-sm-4 col-md-4  text-left">
                    </div>
                    <div class="col-9 col-sm-8 col-md-8"
                         *ngIf="(orderDetail.OrderStatusId == 4 || orderDetail.OrderStatusId == 6) && userRole === 'EndUser'; else notShow">
                      <div class="row">
                        <div class="col-5 col-md-5">
                        </div>
                        <div class="col-7 col-md-7"
                             *ngIf="(orderDetail.OrderStatusId == 4 || orderDetail.OrderStatusId == 6) && userRole === 'EndUser'">
                          <input type='button' class="chng-img-spc mat-btn wrt-rvw-btn" value="Write a review"
                                 (click)="openRatingReviewDialog(item.ProductId,orderDetail.OrderNo,item.CustomizedProductid)">
                        </div>
                      </div>
                    </div>
                    <ng-template #notShow>
                      <div class="col-9 col-sm-8 col-md-8 text-right">
                        <p *ngIf="orderDetail.IsShopifyOrder && item.ShopifyUnitPrice > 0">{{ item.ShopifyUnitPrice * item.Quantity | currency:'USD':'symbol':'1.2-2'}}</p>
                        <p *ngIf="!(orderDetail.IsShopifyOrder && item.ShopifyUnitPrice > 0)">{{ item.UnitPrice * item.Quantity | currency:'USD':'symbol':'1.2-2'}}</p>
                      </div>
                    </ng-template>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-xs-12">
                    <div *ngFor="let s of item.SidesImages" class="detail-img-product">
                      <a target="_blank"
                         href="{{orderDetail.IsOrderDeskOrder ? s.ProductThumnailURL : (imgBaseURL + s.ProductThumnailURL)}}">
                        <div class="link-img">
                          <img src="{{orderDetail.IsOrderDeskOrder ? s.ProductThumnailURL : (imgBaseURL + s.ProductThumnailURL)}}"
                               height="50" />
                          <br />
                          {{s.Name}}
                        </div>
                      </a>

                      <small class="print-size-label" *ngIf="(userRole === 'SuperAdmin' || userRole === 'CustomerService') && s.ElementCount > 0">
                        {{s.PrintWidthPx | number:'1.0-0'}} &times; {{s.PrintHeightPx | number:'1.0-0'}} px
                        <span *ngIf="s.ElementCount > 1">&middot; {{s.ElementCount}} elements</span>
                      </small>

                      <a target="_blank"
                         href="{{orderDetail.IsOrderDeskOrder ? s.PrintReadyURL : (imgBaseURL + s.PrintReadyURL)}}"
                         class="link-design">
                        Design <i class="fa fa-external-link"></i>
                      </a>
                    </div>
                    <div *ngIf="item.SizeLevelImg != null" class="detail-img-product">
                      <a target="_blank" href="{{item.SizeLevelImg.ProductThumnailURL}}">
                        <div class="link-img">
                          <img src="{{item.SizeLevelImg.ProductThumnailURL}}" height="50" />
                          <br />
                          {{item.SizeLevelImg.Name}}
                        </div>
                      </a>
                      <a target="_blank" href="{{item.SizeLevelImg.PrintReadyURL}}" class="link-design">
                        Design <i class="fa fa-external-link"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <hr>
              </div>
              <div class="crt-rw-rpt">
                <div>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-2 text-center">
                    </div>
                    <div class="col-12 text-sm-center col-sm-12 text-md-left col-md-3">
                    </div>
                    <div class="col-12 col-sm-12 text-sm-center col-md-7 txtsmall">
                      <div class="row">
                        <div class="col-7 col-sm-6 col-md-8  text-right">
                          <h6><strong class="txtsmall">Subtotal </strong></h6>
                        </div>
                        <div *ngIf="orderDetail.IsShopifyOrder" class="col-4 col-sm-6 col-md-4">
                          {{ (orderDetail.ShopifyOrderTotal > 0 ? orderDetail.ShopifyOrderTotal : shopifyTotal) - orderDetail.ShippingCost - (orderDetail.SalesTaxAmount || 0) | currency:'USD':'symbol':'1.2-2'}}
                        </div>
                        <div *ngIf="!orderDetail.IsShopifyOrder" class="col-4 col-sm-6 col-md-4">
                          {{orderDetail.SubTotal | currency:'USD':'symbol':'1.2-2'}}
                        </div>
                      </div>
                      <div class="row" *ngIf="orderDetail.Discount">
                        <div class="col-7 col-sm-6 col-md-8  text-right small">
                          <h6><strong class="txtsmall">Discount (if any)</strong></h6>
                        </div>
                        <div class="col-5 col-sm-6 col-md-4">
                          -{{orderDetail.Discount | currency:'USD':'symbol':'1.2-2'}}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-7 col-sm-6 col-md-8  text-right small">
                          <h6><strong class="txtsmall">Shipping Charges (if any)</strong></h6>
                        </div>
                        <div class="col-5 col-sm-6 col-md-4">
                          +{{orderDetail.ShippingCost | currency:'USD':'symbol':'1.2-2'}}
                        </div>
                      </div>
                      <div class="row" *ngIf="orderDetail.SalesTaxAmount">
                        <div class="col-7 col-sm-6 col-md-8  text-right small">
                          <h6><strong class="txtsmall">Sales Tax (if any)</strong></h6>
                        </div>
                        <div class="col-5 col-sm-6 col-md-4">
                          +{{orderDetail.SalesTaxAmount | currency:'USD':'symbol':'1.2-2'}}
                        </div>
                      </div>
                      <div class="row" *ngIf="orderDetail.IsShopifyOrder && getShopifyDiscounts(orderDetail.ShopifyDiscounts).length > 0">
                        <div class="col-7 col-sm-6 col-md-8  text-right small">
                          <h6><strong class="txtsmall">Shopify Discounts</strong></h6>
                        </div>
                        <div class="col-5 col-sm-6 col-md-4 small">
                          <div *ngFor="let d of getShopifyDiscounts(orderDetail.ShopifyDiscounts)">{{ d }}</div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-7 col-sm-6 col-md-8  text-right">
                          <h6><strong class="txtsmall">Amount Paid </strong></h6>
                        </div>
                        <div *ngIf="orderDetail.IsShopifyOrder" class="col-5 col-sm-6 col-md-4">
                          {{ (orderDetail.ShopifyOrderTotal > 0 ? orderDetail.ShopifyOrderTotal : shopifyTotal) | currency:'USD':'symbol':'1.2-2'}}
                        </div>
                        <div *ngIf="!orderDetail.IsShopifyOrder" class="col-5 col-sm-6 col-md-4">
                          {{ orderDetail.TotalPrice | currency:'USD':'symbol':'1.2-2'}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <h3 class="track-head">Track Order</h3>
            <div class="track-card">
              <div class="trck-od-prgrs" [ngClass]="{
							'trck-od-prgrs3':orderDetail.OrderStatusId == 3,
							'trck-od-prgrs2 canceled-prgrs-2': (orderDetail.OrderStatusId == 4 && orderDetail.PreviousOrderStatusId == 2 ),
							'trck-od-prgrs2':orderDetail.OrderStatusId == 2,
							'trck-od-prgrs1 canceled-prgrs-1': (orderDetail.OrderStatusId == 4 && orderDetail.PreviousOrderStatusId == 1),
							'trck-od-prgrs1': (orderDetail.OrderStatusId == 1),
							'trck-od-prgrs4':orderDetail.OrderStatusId == 5,
							'trck-od-prgrs5':orderDetail.OrderStatusId == 6
						  }">
                <div class="progress">
                  <div class="one primary-color" [matTooltip]="orderDetail.OrderDate">
                    <p>Ordered</p>
                    <i class="fa fa-home no-background"></i>
                  </div>
                  <div class="two primary-color"
                       [matTooltip]="orderDetail.ConfirmationDate ? orderDetail.ConfirmationDate: ''">
                    <p>
                      Confirmed
                    </p>
                    <i class="fa fa-check no-background"></i>
                  </div>
                  <div class="three primary-color"
                       [matTooltip]="orderDetail.OrderStatusId == 7 ? 'Produced': orderDetail.ConfirmationDate ? 'Confirmation Pending': 'Under Production'">
                    <p>
                      Produced
                    </p>
                    <i class="fa fa-thumbs-up no-background"></i>
                  </div>
                  <div class="four primary-color"
                       [matTooltip]="orderDetail.DispatchedDate ? orderDetail.DispatchedDate: ''">
                    <p>Shipped</p>
                    <i class="fa fa-truck no-background"></i>
                  </div>
                  <div class="progress-bar" style="width: 100%;"></div>
                </div>
              </div>
              <div class="row" *ngIf="userRole === 'SuperAdmin'||userRole==='CustomerService'">
                <div class="col-sm-12 od-st-blk">
                  <label style="font-size:13px;">Update order Status</label>
                  <mat-form-field floatPlaceholder="never">
                    <mat-select [(ngModel)]='selectedValue' class="order-st-select" [disabled]="true"
                                (selectionChange)="fn_UpdateOrderStatus($event.value)">
                      <mat-option value="1" [value]="1"
                                  [disabled]="orderDetail.OrderStatusId == 4 || (orderDetail.OrderStatusId >= 1)">Ordered</mat-option>
                      <mat-option value="2" [value]="2"
                                  [disabled]="orderDetail.OrderStatusId == 4 || (orderDetail.OrderStatusId >= 2)">Confirmed</mat-option>
                      <mat-option value="5" [value]="5"
                                  [disabled]="orderDetail.OrderStatusId == 4 || (orderDetail.OrderStatusId >= 5)">Shipped</mat-option>
                      <mat-option value="4" [value]="4" [disabled]="orderDetail.OrderStatusId >= 4">Cancel</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br /><br />
        <div *ngIf="userRole === 'SuperAdmin' || userRole==='CustomerService'"
             class="row sp-admin-list-tbl pro-tble-outer">
          <div class="table-responsive col-md-12" *ngIf="orderDetail.OrderLogs && orderDetail.OrderLogs.length>0"
               style="font-size:11px;">
            <h4 class="text-center"><u><strong>Order Logs</strong></u></h4><br />
            <table style="width:100%">
              <thead>
                <tr>
                  <th width="30">#</th>
                  <!--  <th width="80">Order Number</th>-->
                  <th width="80">Event Type</th>
                  <th width="80">Status</th>
                  <th width="300">Description</th>
                  <th width="150">Activity Date</th>
                </tr>
              </thead>
              <tbody class="row-1-col-1 border-right">
                <tr *ngFor="let item of orderDetail.OrderLogs; let i=index;">
                  <td>{{i + 1}}</td>

                  <!--<td>{{item.OrderNumber}}</td>-->
                  <td>{{item.ActivityStatus}}</td>
                  <td class="text-info" *ngIf="item.Status">Success</td>
                  <td class="text-danger" *ngIf="!item.Status">Failed</td>
                  <td>{{item.Description}}</td>
                  <td>{{getDate(item.ActivityDateTime,true)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  </div>
